import { render, staticRenderFns } from "./CreateBlacklist.vue?vue&type=template&id=0f04cf14&scoped=true"
import script from "./CreateBlacklist.vue?vue&type=script&lang=js"
export * from "./CreateBlacklist.vue?vue&type=script&lang=js"
import style0 from "./CreateBlacklist.vue?vue&type=style&index=0&id=0f04cf14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04cf14",
  null
  
)

export default component.exports